import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import PublicMenu from './pages/PublicMenu';
import Payment from './pages/Payment';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import PaymentCallback from './pages/PaymentCallback';
import ReadyToPay from './pages/ReadyToPay';
import SessionExpired from './pages/SessionExpired';
import GeneralError from './pages/GeneralError';
import { useSelector } from 'react-redux';
import type { RootState } from './store';
import GlobalLoader from './components/GlobalLoader';
import CustomizeItemPage from './pages/CustomizeItemPage';
import CustomizeItemRecommendedPage from './pages/CustomizeItemRecommendedPage';
import { UserNamePrompt } from './components/UserNamePrompt';
import { PaymentErrorModal } from './components/PaymentErrorModal';
import AnalyticsTracker from './components/AnalyticsTracker';
import WaiterCallButton from './components/WaiterCallButton';

const App = () => {
  const isPageLoading = useSelector((state: RootState) => state.ui.isPageLoading);
  const isCartOpen = useSelector((state: RootState) => state.ui.isCartOpen);
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AnalyticsTracker />
        <WaiterCallButton isCartOpen={isCartOpen} />
        {isPageLoading && <GlobalLoader />}
        <UserNamePrompt />
        <PaymentErrorModal />
        <Routes>          
          <Route path="/table/qr/:qrCode" element={<PublicMenu />} />
          <Route path="/customize-item/:itemId" element={<CustomizeItemPage />} />
          <Route path="/customize-item/:orderId/:orderItemId" element={<CustomizeItemPage />} />
          <Route path="/customize-recommended/:itemId" element={<CustomizeItemRecommendedPage />} />
          <Route path="/payment/:orderId" element={<Payment />} />
          <Route path="/payment/callback/providers/:provider/payloads/*" element={<PaymentCallback />} />          
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />          
          <Route path="/ready-to-pay/:orderId" element={<ReadyToPay />} />
          <Route path="/session-expired" element={<SessionExpired />} />
          <Route path="/error" element={<GeneralError />} />          
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
